<template>
  <b-tab
    title="Anexos"
    :active="isTheCurrentTab"
    @click="() => (store.currentTab = 7)"
    :disabled="!isTheCurrentTab && !store.isUpdate"
    class="mt-5"
  >
    <b-row>
      <b-col md="6">
        <b-form-group label="Anexo 1" label-for="anexo1">
          <div v-if="anexo_1" class="d-flex align-items-center mb-2">
            <a :href="anexo_1" class="rounded-0 mr-2" target="_blank"
              >Visualizar Anexo</a
            >
            <button
              class="btn btn-light-primary btn-sm btn-bold"
              type="button"
              v-b-tooltip.hover="'Remover anexo'"
              @click="removeAnexo('anexo_1', 'anexo_1_file')"
            >
              <TrashCanIcon :size="16" />
            </button>
          </div>
          <b-form-file
            ref="anexo_1_file"
            v-model="fileInputs.anexo_1"
            accept="image/jpeg, image/png, application/pdf, video/*"
            @change="(event) => setAnexo(event, 'anexo_1')"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="6">
        <b-form-group label="Anexo 2" label-for="anexo2">
          <div v-if="anexo_2" class="d-flex align-items-center mb-2">
            <a :href="anexo_2" class="rounded-0 mr-2" target="_blank"
              >Visualizar Anexo</a
            >
            <button
              class="btn btn-light-primary btn-sm btn-bold"
              type="button"
              v-b-tooltip.hover="'Remover anexo'"
              @click="removeAnexo('anexo_2', 'anexo_2_file')"
            >
              <TrashCanIcon :size="16" />
            </button>
          </div>
          <b-form-file
            ref="anexo_2_file"
            v-model="fileInputs.anexo_2"
            accept="image/jpeg, image/png, application/pdf, video/*"
            @change="(event) => setAnexo(event, 'anexo_2')"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="6">
        <b-form-group label="Anexo 3" label-for="anexo3">
          <div v-if="anexo_3" class="d-flex align-items-center mb-2">
            <a :href="anexo_3" class="rounded-0 mr-2" target="_blank"
              >Visualizar Anexo</a
            >
            <button
              class="btn btn-light-primary btn-sm btn-bold"
              type="button"
              v-b-tooltip.hover="'Remover anexo'"
              @click="removeAnexo('anexo_3', 'anexo_3_file')"
            >
              <TrashCanIcon :size="16" />
            </button>
          </div>
          <b-form-file
            ref="anexo_3_file"
            v-model="fileInputs.anexo_3"
            accept="image/jpeg, image/png, application/pdf, video/*"
            @change="(event) => setAnexo(event, 'anexo_3')"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="6">
        <b-form-group label="Anexo 4" label-for="anexo4">
          <div v-if="anexo_4" class="d-flex align-items-center mb-2">
            <a :href="anexo_4" class="rounded-0 mr-2" target="_blank"
              >Visualizar Anexo</a
            >
            <button
              class="btn btn-light-primary btn-sm btn-bold"
              type="button"
              v-b-tooltip.hover="'Remover anexo'"
              @click="removeAnexo('anexo_4', 'anexo_4_file')"
            >
              <TrashCanIcon :size="16" />
            </button>
          </div>
          <b-form-file
            ref="anexo_4_file"
            v-model="fileInputs.anexo_4"
            accept="image/jpeg, image/png, application/pdf, video/*"
            @change="(event) => setAnexo(event, 'anexo_4')"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="6">
        <b-form-group label="Anexo 5" label-for="anexo5">
          <div v-if="anexo_5" class="d-flex align-items-center mb-2">
            <a :href="anexo_5" class="rounded-0 mr-2" target="_blank"
              >Visualizar Anexo</a
            >
            <button
              class="btn btn-light-primary btn-sm btn-bold"
              type="button"
              v-b-tooltip.hover="'Remover anexo'"
              @click="removeAnexo('anexo_5', 'anexo_5_file')"
            >
              <TrashCanIcon :size="16" />
            </button>
          </div>
          <b-form-file
            ref="anexo_5_file"
            v-model="fileInputs.anexo_5"
            accept="image/jpeg, image/png, application/pdf, video/*"
            @change="(event) => setAnexo(event, 'anexo_5')"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="6">
        <b-form-group label="Anexo 6" label-for="anexo6">
          <div v-if="anexo_6" class="d-flex align-items-center mb-2">
            <a :href="anexo_6" class="rounded-0 mr-2" target="_blank"
              >Visualizar Anexo</a
            >
            <button
              class="btn btn-light-primary btn-sm btn-bold"
              type="button"
              v-b-tooltip.hover="'Remover anexo'"
              @click="removeAnexo('anexo_6', 'anexo_6_file')"
            >
              <TrashCanIcon :size="16" />
            </button>
          </div>
          <b-form-file
            ref="anexo_6_file"
            v-model="fileInputs.anexo_6"
            accept="image/jpeg, image/png, application/pdf, video/*"
            @change="(event) => setAnexo(event, 'anexo_6')"
          />
        </b-form-group>
      </b-col>
    </b-row>
  </b-tab>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";
import "vue-select/dist/vue-select.css";
import { validationMixin } from "vuelidate";
import { SistemaMixin, ValidacaoMixin } from "@/modules/Application";
import _ from "lodash";
import { store } from "../../storeOS";
import TrashCanIcon from "vue-material-design-icons/TrashCan.vue";

export default {
  name: "app-os-form-anexosTab",
  data() {
    return {
      store,
      anexo_1: null,
      anexo_2: null,
      anexo_3: null,
      anexo_4: null,
      anexo_5: null,
      anexo_6: null,
      form: {
        anexo_1: null,
        anexo_2: null,
        anexo_3: null,
        anexo_4: null,
        anexo_5: null,
        anexo_6: null,
        remover_anexos: [],
      },
      fileInputs: {
        anexo_1: null,
        anexo_2: null,
        anexo_3: null,
        anexo_4: null,
        anexo_5: null,
        anexo_6: null,
      },
      tabCurrent: 7,
    };
  },
  mixins: [validationMixin, SistemaMixin, ValidacaoMixin],
  components: {
    TrashCanIcon,
  },
  methods: {
    ...mapActions(["setLoading"]),
    async setAnexo(event, anexo) {
      const data = await event.target.files[0];
      if (!data) return;

      this.removeFromRemovedList(anexo);
      this.revokeObjectUrl(this[anexo]);

      const url = URL.createObjectURL(data);
      this[anexo] = url;
      this.form[anexo] = data;
    },
    removeAnexo(anexo, refName) {
      this.revokeObjectUrl(this[anexo]);
      this[anexo] = null;
      this.form[anexo] = null;
      this.fileInputs[anexo] = null;

      if (this.$route.params.osData && this.$route.params.osData[anexo]) {
        this.addToRemovedList(anexo);
      }

      const fileInput = this.$refs[refName];
      if (fileInput?.reset) {
        fileInput.reset();
      }
    },
    addToRemovedList(anexo) {
      if (!this.form.remover_anexos.includes(anexo)) {
        this.form.remover_anexos.push(anexo);
      }
    },
    removeFromRemovedList(anexo) {
      this.form.remover_anexos = this.form.remover_anexos.filter(
        (anexoRemovido) => anexoRemovido !== anexo
      );
    },
    revokeObjectUrl(url) {
      if (url && url.startsWith("blob:")) {
        URL.revokeObjectURL(url);
      }
    },
  },
  watch: {
    form: {
      handler(value) {
        this.store.formAnexos = value;
      },
      deep: true,
    },
  },
  created() {
    if (Object.keys(this.$route.params).length !== 0) {
      const { anexo_1, anexo_2, anexo_3, anexo_4, anexo_5, anexo_6 } =
        this.$route.params.osData;

      this.anexo_1 = anexo_1;
      this.form.anexo_1 = anexo_1;
      this.anexo_2 = anexo_2;
      this.form.anexo_2 = anexo_2;
      this.anexo_3 = anexo_3;
      this.form.anexo_3 = anexo_3;
      this.anexo_4 = anexo_4;
      this.form.anexo_4 = anexo_4;
      this.anexo_5 = anexo_5;
      this.form.anexo_5 = anexo_5;
      this.anexo_6 = anexo_6;
      this.form.anexo_6 = anexo_6;
    }
  },
  computed: {
    ...mapGetters([
      "isAuthenticated",
      "breadcrumbs",
      "pageTitle",
      "layoutConfig",
    ]),
    ...mapState(["loading"]),
    isLoading() {
      return this.loading.loading;
    },
    isTheCurrentTab() {
      if (store.trabalharHorasOs) {
        this.tabCurrent == 8;
      }
      return store.currentTab === this.tabCurrent;
    },
  },
};
</script>
